import React from 'react';

function SummaryDisplay({ finalSummary, finalFilePath, tokensUsed, backendUrl }) {
  if (!finalSummary) return null;

  const encodedPath = finalFilePath ? encodeURIComponent(finalFilePath.replace(/\\/g, '/')) : '';

  return (
    <div className="mt-4">
      <h4>Final Summary</h4>
      <pre style={{
        backgroundColor: '#f8f9fa',
        padding: '1rem',
        borderRadius: '8px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
        fontSize: '0.95rem',
        border: '1px solid #ddd',
      }}>
        {finalSummary}
      </pre>
      {tokensUsed > 0 && (
        <p className="text-muted">
          Total Tokens: {tokensUsed} — Estimated Cost: ${(tokensUsed * 0.000015).toFixed(4)} USD
        </p>
      )}
      {finalFilePath && (
        <a
          href={`${backendUrl}/analyzer/api/download_page/?file_path=${encodedPath}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="btn btn-info mt-2">Download Report</button>
        </a>
      )}
    </div>
  );
}

export default SummaryDisplay;
